import type { CSSProperties } from 'react';
import { cx } from '../../utils/cx';
import s from './Skeleton.module.css';

type Base = { className?: string };

/** Loading placeholders shaped like the content. Decorative: pair with an aria-busy region. */
function Text({
  lines = 1,
  lastWidth = '60%',
  className,
}: Base & { lines?: number; lastWidth?: string }) {
  return (
    <span className={cx(s.textGroup, className)} aria-hidden="true">
      {Array.from({ length: lines }, (_, i) => (
        <span
          key={i}
          className={cx(s.bone, s.line)}
          style={i === lines - 1 && lines > 1 ? { width: lastWidth } : undefined}
        />
      ))}
    </span>
  );
}

function Circle({ size = 'var(--gg-size-avatar-md)', className }: Base & { size?: string }) {
  return (
    <span
      className={cx(s.bone, s.circle, className)}
      style={{ width: size, height: size }}
      aria-hidden="true"
    />
  );
}

function Rect({
  width = '100%',
  height = 'var(--gg-size-thumb-sm)',
  radius = 'var(--gg-radius-md)',
  className,
}: Base & { width?: string; height?: string; radius?: string }) {
  return (
    <span
      className={cx(s.bone, s.rect, className)}
      style={{ width, height, borderRadius: radius } as CSSProperties}
      aria-hidden="true"
    />
  );
}

export const Skeleton = { Text, Circle, Rect };
